import React, { Fragment, useContext, useEffect } from "react"
import { GameBoardContext } from "../../context/createContext"
import useReize from "../../helpers/useResize"
import SettingsEach from "./settingsPopup/SettingsEach"
import { SettingsWrapper, SettingsPageContainer } from "./SettingsStyles"
import GameRules from "../gameRules/GameRules"
import History from "../history/History"
import JackpotRules from "../gameRules/JackpotRules"

export default function Settings({ history }: any) {
  const { settings } = useContext(GameBoardContext)

  const { isMobile } = useReize()

  const show =
    settings.settingsSubpage !== "" && settings.settingsSubpage !== "Settings"
  return (
    <Fragment>
      {show && (
        <SettingsWrapper showSettings={show}>
          <SettingsPageContainer showSettings={show}>
            {settings.settingsSubpage === "History" && (
              <History history={history} />
            )}
            {settings.settingsSubpage === "Game_Rules" && <GameRules />}
            {settings.settingsSubpage === "Jackpot_Rules" && <JackpotRules />}
          </SettingsPageContainer>
        </SettingsWrapper>
      )}
      {!isMobile && (
        <SettingsEach history={history} title={settings.settingsSubpage} />
      )}
    </Fragment>
  )
}
